import "./App.css";
import { theme } from "@ovotech/element";
import { ThemeProvider } from "styled-components";
import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";
import { OverlayProvider } from "@react-aria/overlays";

import "@ovotech/element/dist/reset.css";
import { ApiClient, createApiClient } from "./services/api";
import PostcodeCard from "./components/PostcodeCard/PostcodeCard";
import TariffList from "./components/TariffList/TariffList";
import { HoldingBanner } from "./components/HoldingBanner/HoldingBanner";

export interface IPageContext {
  apiClient: ApiClient;
  setPostcode: Dispatch<SetStateAction<string | null>>;
  setRegion: Dispatch<SetStateAction<string | null>>;
}

export const PageContext = createContext<{
  apiClient: ApiClient | null;
  setPostcode: Dispatch<SetStateAction<string | null>> | null;
  setRegion: Dispatch<SetStateAction<string | null>> | null;
}>({ apiClient: null, setPostcode: null, setRegion: null });

export function usePageContext(): IPageContext {
  const { apiClient, setPostcode, setRegion } = useContext(PageContext);

  if (apiClient === null) {
    throw new Error("API client is not defined");
  }

  if (setPostcode === null) {
    throw new Error("Set postcode function is not defined");
  }

  if (setRegion === null) {
    throw new Error("Set region function is not defined");
  }

  return { apiClient, setPostcode, setRegion };
}

function App() {
  const [postcode, setPostcode] = useState<string | null>("");
  const [region, setRegion] = useState<string | null>("");
  return (
    <ThemeProvider theme={theme}>
      <PageContext.Provider
        value={{
          apiClient: createApiClient({
            fetchClient: fetch,
            apiHost: process.env.REACT_APP_API_HOST || "http://localhost:8080",
          }),
          setPostcode,
          setRegion,
        }}
      >
        <OverlayProvider>
          <main className="flex-center-container">
            <div className="content-wrapper">
              {process.env.REACT_APP_HOLDING_BANNER ? (
                <HoldingBanner />
              ) : (
                <PostcodeCard />
              )}
              {postcode && postcode.length > 0 ? (
                <TariffList postcode={postcode} region={region} />
              ) : null}
            </div>
          </main>
        </OverlayProvider>
      </PageContext.Provider>
    </ThemeProvider>
  );
}

export default App;
